import * as React from 'react';
import * as d3Axis from 'd3-axis';
import {select} from 'd3-selection';
import {ScaleLinear, ScaleTime} from 'd3-scale';
import {Margins, Size} from '../../types';
import {theme} from '../style';

interface Scales {
  xScale: ScaleLinear<number, number> | ScaleTime<number, number>;
  yScale: ScaleLinear<number, number>;
}

interface CleanArrowLeftAxisProps {
  scales: Scales;
  margins: Margins;
  svgDimensions: Size;
  label: string;
}

/**
 * A clean, singular bottom axis with label.
 * Note that this doesn't actually use d3 axis
 *
 * label - string label for the axis
 */
export class CleanArrowBottomAxis extends React.Component<CleanArrowLeftAxisProps> {
  private readonly axisElement: React.RefObject<SVGSVGElement>;

  constructor(props: CleanArrowLeftAxisProps) {
    super(props);
    this.axisElement = React.createRef();
  }

  static getDefinitions() {
    return (
      <marker
        id="arrowhead"
        viewBox="0 0 10 10"
        refX="7"
        refY="5"
        markerUnits="strokeWidth"
        markerWidth="6"
        markerHeight="3"
        orient="auto">
        <path d="M 0 0 L 10 5 L 0 10 z" stroke="none" fill={theme.colors.chartTextPrimary} />
      </marker>
    );
  }

  componentDidMount() {
    this.renderAxis();
  }

  componentDidUpdate() {
    this.renderAxis();
  }

  renderAxis() {
    const {scales} = this.props;

    const axis = d3Axis.axisBottom(scales.xScale).ticks(0).tickSize(0);

    select(this.axisElement.current!).call(axis);
  }

  render() {
    const {margins, scales, svgDimensions, label} = this.props;

    return (
      <g>
        <g
          className={`Axis Axis-bottom`}
          ref={this.axisElement}
          markerEnd={'url(#arrowhead)'}
          transform={`translate(0, ${scales.yScale.range()[0] + margins.top})`}
          style={{color: theme.colors.chartTextPrimary}}
        />
        <text
          y={scales.yScale.range()[0] + margins.top + margins.bottom}
          x={(svgDimensions.width + margins.left) / 2}
          textAnchor="middle"
          fontFamily={theme.fonts.primaryFontFamily}
          fontSize="10px"
          fill={theme.colors.chartTextTertiary}
          fontWeight="bold">
          {label}
        </text>
      </g>
    );
  }
}
